// mergeMeData.js
'use strict';
import { MERGE_ME_DATA, SET_ME_DATA } from '../ActionTypes.js';

const availableFields = [
  'token',
  'refreshToken',
  'defaultUsername',
  'fcmToken',
  'pushyToken',
  'biography',
  'birthdate',
  'gender',
  'currency',
  'usingList',
  'email',
  'downloadMobileApp',
  'hasAgeVerified',
  'lastNotSupportAlertTimestamp',
  'lastAgeVerifierConfirmTimestamp',
  'accountLinks',
  'intercomUserHash',
  'zendeskUserJwt',
  'closeDownloadSchatModalTimestamp',
  'closeEmailBindingAlertTimestamp',
  'utm',
  'clientId',
  'country',
  'defaultCountryCode',
  'regionGroup',
  'balance',
  'purchaseCount',
  'creator',
  'contract',
  'subscriptionPlan',
  'scorebook',
  'redirect',
  'aquisitionAuthToken',
  'jwtData',
  'refreshTokenJwtData',
  'giftPromotionModalShowCount',
  'firstPromotionModalStartTimestamp',
];

/**
 * Merge me data
 * @kind action
 * @param {string} {field} - me data field.
 * @param {any} {value} - value.
 * @return {Promise} Action promise.
 */
const mergeMeData =
  ({ field, value }) =>
  async dispatch => {
    if (!availableFields.includes(field)) {
      return dispatch({ type: '' });
    }

    if (field === 'jwtData') {
      return dispatch({
        type: SET_ME_DATA,
        payload: { selectPath: 'jwtData', value },
      });
    }
    return dispatch({ type: MERGE_ME_DATA, payload: { [field]: value } });
  };

export default mergeMeData;
